import { QuestionFormType } from './types'

export const InitialQuestionForm: QuestionFormType = {
  country: '',
  email: '',
  fullName: '',
  message: '',
  phone: '',
}
